module.exports = __webpack_public_path__ + "img/send.52e8f2e0.svg";